import { useRegion } from 'common/hooks/region';
import * as React from 'react';
import { Filters } from './Filters';
import { Preview } from './Preview';

/**
 * Renders the filters and snapshots when searching for snapshots by terminal
 */
export const ByTerminal: React.FC = () => {
  const region = useRegion();

  return (
    <div className="px-16 space-y-16">
      <Filters key={region.code} />
      <Preview />
    </div>
  );
};
ByTerminal.displayName = 'ByTerminal';
